export default __webpack_public_path__ + "static/media/plan4-col5-img.df28788c.svg";